var _g;

var _excluded = ["svgRef", "title"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var SvgMedium = function SvgMedium(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 30,
    height: 23.062,
    viewBox: "0 0 30 23.062",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_1346",
    "data-name": "Group 1346",
    transform: "translate(-1307 -4559.938)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Ellipse_117",
    "data-name": "Ellipse 117",
    transform: "translate(1307 4571)",
    fill: "none",
    stroke: "#fc7600",
    strokeWidth: 1
  }, /*#__PURE__*/React.createElement("ellipse", {
    cx: 15,
    cy: 6,
    rx: 15,
    ry: 6,
    stroke: "none"
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 15,
    cy: 6,
    rx: 14.5,
    ry: 5.5,
    fill: "none"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_1343",
    "data-name": "Group 1343",
    transform: "translate(40 40)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_1340",
    "data-name": "Group 1340",
    transform: "translate(1271.487 4519.938)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Page-1",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "_020---Stadium",
    "data-name": "020---Stadium",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Shape",
    d: "M22.532,43.7c0,1.229-4.819,2.6-10.766,2.6S1,44.928,1,43.7c0-.512.835-.984,2.235-1.359v0a.144.144,0,0,0-.007.056c0,.691,2.142,1.492,5.2,1.849.475.059.969.1,1.485.134.6.041,1.218.059,1.856.059.772,0,1.518-.03,2.227-.085.516-.037,1.013-.089,1.485-.152,2.855-.379,4.826-1.14,4.826-1.8a.144.144,0,0,0-.007-.056v0C21.7,42.715,22.532,43.186,22.532,43.7Z",
    transform: "translate(-0.629 -26.622)",
    fill: "#2e2e2e"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Shape-2",
    "data-name": "Shape",
    d: "M37.588,42.34v0a.144.144,0,0,1,.007.056.461.461,0,0,1-.106.271c.774.307,1.22.657,1.22,1.028,0,1.19-4.521,2.513-10.209,2.595q.277,0,.557,0c5.947,0,10.766-1.37,10.766-2.6C39.823,43.186,38.988,42.715,37.588,42.34Z",
    transform: "translate(-17.92 -26.622)",
    fill: "#2e2e2e"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Shape-3",
    "data-name": "Shape",
    d: "M22.534,14.554l-.033.252c-.137.371-.631.72-1.385,1.032a5.5,5.5,0,0,0-2.19-1.073,20.407,20.407,0,0,0-2.821-.6,28.783,28.783,0,0,0-2.985-.282c-.445-.019-.9-.03-1.348-.03s-.9.011-1.348.03a28.783,28.783,0,0,0-2.985.282,20.406,20.406,0,0,0-2.821.6,5.453,5.453,0,0,0-2.19,1.073c-.754-.312-1.247-.661-1.385-1.032l-.033-.252C1.118,13.14,6.5,12,11.772,12s10.655,1.14,10.762,2.554Z",
    transform: "translate(-0.635 -7.545)",
    fill: "#5b5b5b"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Shape-4",
    "data-name": "Shape",
    d: "M1,18.88l.033.252A.572.572,0,0,1,1,18.925.181.181,0,0,1,1,18.88Z",
    transform: "translate(-0.629 -11.871)",
    fill: "#0377bc"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Shape-5",
    "data-name": "Shape",
    d: "M23.518,18.982a14.059,14.059,0,0,1-2.469.705,8.94,8.94,0,0,0-1.826-.46c-.579-.093-1.236-.174-1.934-.238-.668-.059-1.374-.1-2.094-.119-.338-.011-.679-.015-1.021-.015s-.683,0-1.021.015c-.72.019-1.426.059-2.094.119-.7.063-1.355.145-1.934.238a9.006,9.006,0,0,0-1.826.46,14.058,14.058,0,0,1-2.469-.705A5.453,5.453,0,0,1,7.02,17.91a20.406,20.406,0,0,1,2.821-.6,28.783,28.783,0,0,1,2.985-.282c.445-.019.9-.03,1.348-.03s.9.011,1.348.03a28.783,28.783,0,0,1,2.985.282,20.406,20.406,0,0,1,2.821.6,5.5,5.5,0,0,1,2.19,1.073Z",
    transform: "translate(-3.037 -10.689)",
    fill: "#7f8e94"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Shape-6",
    "data-name": "Shape",
    d: "M25.231,22.832a35.05,35.05,0,0,1-6.875.653,35.05,35.05,0,0,1-6.875-.653,9.007,9.007,0,0,1,1.826-.46c.579-.093,1.236-.174,1.934-.238.668-.059,1.374-.1,2.094-.119C17.672,22,18.014,22,18.355,22s.683,0,1.021.015c.72.019,1.426.059,2.094.119.7.063,1.355.145,1.934.238a8.941,8.941,0,0,1,1.826.46Z",
    transform: "translate(-7.218 -13.833)",
    fill: "#5b5b5b"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Shape-7",
    "data-name": "Shape",
    d: "M58.937,18.925a.572.572,0,0,1-.037.208l.033-.252A.181.181,0,0,1,58.937,18.925Z",
    transform: "translate(-37.034 -11.871)",
    fill: "#0377bc"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Shape-8",
    "data-name": "Shape",
    d: "M22.558,19.56l0,.03v0L20.36,28.017v0a.144.144,0,0,1,.007.056c0,.665-1.971,1.426-4.826,1.8V28.262a2.974,2.974,0,0,0-2.97-2.97H11.458a2.974,2.974,0,0,0-2.97,2.97v1.663c-3.055-.356-5.2-1.158-5.2-1.849a.144.144,0,0,1,.007-.056v0L1.1,19.593v0l0-.03c.137.371.631.72,1.385,1.032a14.058,14.058,0,0,0,2.469.705,35.05,35.05,0,0,0,6.875.653A35.05,35.05,0,0,0,18.7,21.3a14.058,14.058,0,0,0,2.469-.705C21.927,20.28,22.42,19.931,22.558,19.56Z",
    transform: "translate(-0.692 -12.299)",
    fill: "#5b5b5b"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Shape-9",
    "data-name": "Shape",
    d: "M45.64,20.588,43.7,28.021a.145.145,0,0,1,.007.056c0,.574-1.472,1.219-3.712,1.629v.176c2.855-.379,4.826-1.14,4.826-1.8a.145.145,0,0,0-.007-.056v0l2.194-8.423v0l0-.03C46.879,19.93,46.389,20.278,45.64,20.588Z",
    transform: "translate(-25.15 -12.299)",
    fill: "#2e2e2e"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Shape-10",
    "data-name": "Shape",
    d: "M29.084,40.485v1.771c-.709.056-1.455.085-2.227.085-.639,0-1.259-.019-1.856-.059v-1.8A1.485,1.485,0,0,1,26.485,39H27.6A1.485,1.485,0,0,1,29.084,40.485Z",
    transform: "translate(-15.719 -24.522)",
    fill: "#37474f"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Shape-11",
    "data-name": "Shape",
    d: "M28.054,37.97v1.619c-.471.063-.969.115-1.485.152V37.97a1.485,1.485,0,0,0-1.485-1.485H23.97a1.485,1.485,0,0,0-1.485,1.485v1.8c-.516-.03-1.01-.074-1.485-.134V37.97A2.974,2.974,0,0,1,23.97,35h1.114A2.974,2.974,0,0,1,28.054,37.97Z",
    transform: "translate(-13.204 -22.007)",
    fill: "#ffeb3a"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_869",
    "data-name": "Group 869",
    transform: "translate(2.97 0.371)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Shape-12",
    "data-name": "Shape",
    d: "M19,2l2.6,1.114L19,4.227Z",
    transform: "translate(-14.916 -1.629)",
    fill: "#ef314c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Shape-13",
    "data-name": "Shape",
    d: "M52,5l2.6,1.114L52,7.227Z",
    transform: "translate(-35.665 -3.515)",
    fill: "#ef314c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Shape-14",
    "data-name": "Shape",
    d: "M8,5l2.6,1.114L8,7.227Z",
    transform: "translate(-8 -3.515)",
    fill: "#ef314c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Shape-15",
    "data-name": "Shape",
    d: "M41,2l2.6,1.114L41,4.227Z",
    transform: "translate(-28.749 -1.629)",
    fill: "#ef314c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Shape-16",
    "data-name": "Shape",
    d: "M30,1l2.6,1.114L30,3.227Z",
    transform: "translate(-21.833 -1)",
    fill: "#ef314c"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Shape-17",
    "data-name": "Shape",
    d: "M8.487,33.2a.371.371,0,0,1-.36-.281L7.013,28.466a.371.371,0,0,1,.72-.18L8.847,32.74a.371.371,0,0,1-.27.45A.36.36,0,0,1,8.487,33.2Z",
    transform: "translate(-4.403 -17.61)",
    fill: "#2e2e2e"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Shape-18",
    "data-name": "Shape",
    d: "M22.049,3.311a.371.371,0,0,0,0-.682l-2.6-1.114a.371.371,0,0,0-.518.341V4.938a26.993,26.993,0,0,0-3.341-.587V3.215L17.966,2.2a.371.371,0,0,0,0-.682L15.367.4a.371.371,0,0,0-.518.341V4.269c-1.144-.111-2.292-.173-3.341-.186V2.843l2.374-1.017a.371.371,0,0,0,0-.682L11.283.03a.371.371,0,0,0-.518.341V4.086c-1.049.012-2.2.074-3.341.186V3.215L9.8,2.2a.371.371,0,0,0,0-.682L7.2.4a.371.371,0,0,0-.518.341V4.351a26.993,26.993,0,0,0-3.341.587V4.328L5.715,3.311a.371.371,0,0,0,0-.682l-2.6-1.114a.371.371,0,0,0-.518.341V5.143C1.052,5.615,0,6.248,0,7.054a1.974,1.974,0,0,0,.053.334l2.1,8.077C.712,15.9,0,16.427,0,17.077c0,1.777,5.759,2.97,11.137,2.97s11.137-1.193,11.137-2.97c0-.65-.712-1.179-2.153-1.613l2.1-8.077a2.131,2.131,0,0,0,.053-.334c0-.805-1.052-1.439-2.6-1.911V4.328Zm-2.374-.892,1.285.551-1.285.551ZM15.592,1.306l1.285.551-1.285.551ZM11.508.934l1.285.551-1.285.551Zm-4.084.371,1.285.551-1.285.551ZM3.341,2.419l1.285.551-1.285.551Zm.594,5.208L5.1,8.359a7.047,7.047,0,0,0-.867.254,17.108,17.108,0,0,1-1.657-.434A7.317,7.317,0,0,1,3.935,7.628Zm2.7-.6L7.345,8c-.413.045-.807.1-1.172.156L4.911,7.361c.529-.127,1.113-.239,1.728-.334Zm10.729.334-1.262.791c-.366-.058-.759-.111-1.172-.156l.705-.97c.611.1,1.2.208,1.728.335Zm2.33.817a17.108,17.108,0,0,1-1.657.434,7.048,7.048,0,0,0-.867-.254l1.165-.73a7.317,7.317,0,0,1,1.358.551Zm-8.562.361a31.823,31.823,0,0,1,5.118.391,36.259,36.259,0,0,1-5.118.352A36.259,36.259,0,0,1,6.02,8.929,31.823,31.823,0,0,1,11.137,8.539Zm2.936-.624c-.476-.039-.97-.069-1.475-.089l.194-1.1c.686.037,1.362.1,2.011.179ZM11.848,7.8c-.236,0-.473-.007-.711-.007s-.475,0-.711.008L10.23,6.7c.3-.01.6-.016.907-.016s.605.006.907.016ZM9.482,6.731l.194,1.1c-.5.02-1,.05-1.475.089l-.73-1.006C8.12,6.829,8.8,6.769,9.482,6.731Zm1.655,3.293c3.39,0,8.006-.538,10.067-1.673L19.31,15.62a.373.373,0,0,0-.009.164c-.1.352-1.6,1-4.081,1.371V15.963a3.345,3.345,0,0,0-3.341-3.341H10.766a3.345,3.345,0,0,0-3.341,3.341v1.243c-2.7-.366-4.356-1.057-4.453-1.426a.371.371,0,0,0-.015-.182L1.071,8.35c2.061,1.135,6.676,1.673,10.067,1.673Zm1.856,7.366c-.587.037-1.205.059-1.856.059-.516,0-1.009-.015-1.485-.039V15.963a1.114,1.114,0,0,1,1.114-1.114H11.88a1.114,1.114,0,0,1,1.114,1.114ZM11.88,14.107H10.766A1.858,1.858,0,0,0,8.91,15.963v1.4q-.381-.029-.742-.067V15.963a2.6,2.6,0,0,1,2.6-2.6H11.88a2.6,2.6,0,0,1,2.6,2.6v1.292c-.24.029-.488.054-.742.077v-1.37A1.858,1.858,0,0,0,11.88,14.107Zm9.652,2.97c0,.68-3.927,2.227-10.395,2.227S.742,17.758.742,17.077c0-.151.349-.52,1.607-.9.755,1.22,4.9,2.013,8.787,2.013s8.032-.793,8.787-2.013C21.183,16.557,21.532,16.926,21.532,17.077ZM21.521,7.009c.045.375-.631.7-.976.854C18.733,6.4,13.574,5.94,11.137,5.94c-2.41,0-7.542.42-9.408,1.922a3.948,3.948,0,0,1-.562-.3A1.019,1.019,0,0,1,.791,7.21c-.2-.415.3-.651.68-.844,2.3-1.168,6.995-1.54,9.666-1.54A29.516,29.516,0,0,1,20,6.029a3.861,3.861,0,0,1,1.328.675A.512.512,0,0,1,21.521,7.009Z",
    transform: "translate(0 0)",
    fill: "#2e2e2e"
  }))))))));
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgMedium, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/medium.61d48a96.svg";
export { ForwardRef as ReactComponent };